import React from "react";

const HeaderBottom = () => {
  return (
    <>
      <section
        id="home"
        className="dtr-section dtr-section-with-bg dtr-hero-section-top-padding bg-blue"
        style={{
          backgroundImage:
            "url(https://i.ibb.co/vmw2K4P/Untitled-design-2024-03-12-T114143-198.png)",
          paddingTop: "230px",
        }}
      ></section>
    </>
  );
};

export default HeaderBottom;

